import { render, staticRenderFns } from "./addStockTransfer.vue?vue&type=template&id=9780f154&scoped=true&"
import script from "./addStockTransfer.vue?vue&type=script&lang=js&"
export * from "./addStockTransfer.vue?vue&type=script&lang=js&"
import style0 from "./addStockTransfer.vue?vue&type=style&index=0&id=9780f154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780f154",
  null
  
)

export default component.exports